// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"95fb6890","510":"60261cf8"}[chunkId] + ".chunk.js";
};